import { HttpMethod } from '../../http-method'
import {
  LeaseCompanyCreateServiceOrder,
  LeaseCompanyCreateServiceOrderLine,
  LeaseCompanyCreateUserData,
  LeaseCompanyFixedPrice,
  LeaseCompanyUpdateServiceOrderData,
  LeaseCompanyUpdateServiceOrderLine
} from './lease-company'
import { IPaginatedRequest } from '../../request'
import { TyreType } from '../enums'

export const getLeaseCompanyContract = (workorderUUID: string) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/contracts/${workorderUUID}`
})

export const getLeaseCompanyUsers = () => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/users`
})

export const createLeaseCompanyUser = (Data: LeaseCompanyCreateUserData) => ({
  method: HttpMethod.POST,
  url: `/proxy/lease-api/users`,
  data: { Data }
})

export const updateLeaseCompanyUser = (userUUID: string, Data: LeaseCompanyCreateUserData) => ({
  method: HttpMethod.PUT,
  url: `/proxy/lease-api/users/${userUUID}`,
  data: { Data }
})

export const getLeaseCompanyUser = (userUUID: string) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/users/${userUUID}`
})

export const deleteLeaseCompanyUser = (userUUID: string) => ({
  method: HttpMethod.DELETE,
  url: `/proxy/lease-api/users/${userUUID}`
})

export const testLeaseCompanyUser = (Data: LeaseCompanyCreateUserData) => ({
  method: HttpMethod.POST,
  url: `/proxy/lease-api/users/test`,
  data: { Data }
})

export const getAllLeaseCompanyBranchFormulas = () => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/branch`
})

export const checkLeaseCompanyDefaultUserExists = () => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/users/default/exists`
})

export const getLeaseCompanyDefaultUser = () => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/users/default`
})

export const setLeaseCompanyDefaultUser = (userUUID: string) => ({
  method: HttpMethod.PUT,
  url: `/proxy/lease-api/users/default/${userUUID}`
})

export const getLeaseCompanyBranchFormulaByUser = (userUUID: string) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/branch/by-user/${userUUID}`
})

export const getLeaseCompanySearchResults = (workorderUUID: string, params: IPaginatedRequest) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/component/${workorderUUID}/search`,
  params
})

export const getLeaseCompanyComponent = (workorderUUID: string, code: string) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/component/${workorderUUID}/${code}`
})

export const checkLeaseCompanyServiceOrderExists = (workorderUUID: string) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/service-order/${workorderUUID}/exists`
})

export const getLeaseCompanyServiceOrder = (workorderUUID: string) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/service-order/${workorderUUID}`
})

export const createLeaseCompanyServiceOrder = (workorderUUID: string, Data: LeaseCompanyCreateServiceOrder) => ({
  method: HttpMethod.POST,
  url: `/proxy/lease-api/service-order/${workorderUUID}`,
  data: { Data }
})

export const updateLeaseCompanyServiceOrder = (workorderUUID: string, Data: LeaseCompanyUpdateServiceOrderData) => ({
  method: HttpMethod.PUT,
  url: `/proxy/lease-api/service-order/${workorderUUID}`,
  data: { Data }
})

export const publishLeaseCompanyServiceOrder = (workorderUUID: string) => ({
  method: HttpMethod.PUT,
  url: `/proxy/lease-api/service-order/${workorderUUID}/publish`
})

export const getLeaseCompanyServiceOrderLines = (workorderUUID: string) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/service-order-line/${workorderUUID}`
})

export const createLeaseCompanyServiceOrderLine = (workorderUUID: string, Data: LeaseCompanyCreateServiceOrderLine) => ({
  method: HttpMethod.POST,
  url: `/proxy/lease-api/service-order-line/${workorderUUID}`,
  data: { Data }
})

export const updateLeaseCompanyServiceOrderLine = (
  workorderUUID: string,
  workorderLineUUID: string,
  Data: LeaseCompanyUpdateServiceOrderLine
) => ({
  method: HttpMethod.PUT,
  url: `/proxy/lease-api/service-order-line/${workorderUUID}/${workorderLineUUID}`,
  data: { Data }
})

export const updateLeaseCompanyServiceOrderLineReference = (
  serviceOrderUUID: string,
  serviceOrderLineUUID: string,
  Data: { ReferenceUUID: string }
) => ({
  method: HttpMethod.PUT,
  url: `/proxy/lease-api/service-order/${serviceOrderUUID}/lines/${serviceOrderLineUUID}/link-reference-uuid`,
  data: { Data }
})

export const getLeaseCompanyServiceOrderLine = (workorderUUID: string, workorderLineUUID: string) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/service-order-line/${workorderUUID}/${workorderLineUUID}`
})

export const deleteLeaseCompanyServiceOrderLine = (workorderUUID: string, workorderLineUUID: string) => ({
  method: HttpMethod.DELETE,
  url: `/proxy/lease-api/service-order-line/${workorderUUID}/${workorderLineUUID}`,
  resolveWithFullResponse: true
})

export const getLeaseCompanySearchForTyres = (workorderUUID: string, params: IPaginatedRequest & { season?: TyreType }) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/tyre/${workorderUUID}/search`,
  params
})

export const getLeaseCompanySpecificTyre = (workorderUUID: string, id: string) => ({
  method: HttpMethod.GET,
  url: `proxy/lease-api/${workorderUUID}/tyre/${id}`
})

export const getLeaseCompanyServiceOrderStatuses = () => ({
  method: HttpMethod.GET,
  url: '/proxy/lease-api/service-order/recently-updated-status'
})

export const getLeaseCompanyFixedPrice = (workorderUUID: string, Data: LeaseCompanyFixedPrice) => ({
  method: HttpMethod.POST,
  url: `/proxy/lease-api/contracts/${workorderUUID}/price`,
  data: { Data }
})

export const getLeaseCompanyInvoiceSummary = (workorderUUID: string) => ({
  method: HttpMethod.GET,
  url: `/proxy/lease-api/invoice/${workorderUUID}/summary`
})
